import React, { useState, useMemo } from 'react';
import { useTable, useFilters, usePagination, useSortBy, useFlexLayout } from 'react-table';
import columns from './Columns';
import './RiskTable.css'; // Import the CSS file

import SortDown from "../../assets/images/sortdown.svg";
import SortUp from "../../assets/images/sortup.svg";





const IncidentsTable = ({ data, openpopup }) => {
  /* const [filterInput, setFilterInput] = useState({
       Department: '',
       Owner: '',
       Status: ''
   });
   */
  // --- search & filters state ---


  const [q, setQ] = useState("");
  const [dept, setDept] = useState("All");

  const norm = (v) =>
  String(v ?? "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")  // strip accents
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

  // build department options from data
  const departmentOptions = useMemo(() => {
  const seen = new Map();
  (data || []).forEach((u) => {
    const raw = u.department ?? u.department_name ?? u.dept ?? "";
    const key = norm(raw);
    if (key && !seen.has(key)) seen.set(key, String(raw));
  });
  return ["All", ...Array.from(seen.values())];
}, [data]);

  // filtered data that feeds the table
const filteredData = useMemo(() => {
  const tokens = norm(q).split(" ").filter(Boolean);
  const deptKey = norm(dept);

  return (data || []).filter((u) => {
    // build a searchable haystack from common fields
    const first = u.first_name ?? u.firstName ?? "";
    const last  = u.last_name ?? u.lastName ?? "";
    const full  = [first, last].filter(Boolean).join(" ");
    const name  = u.name ?? full; // prefer name, else first+last

    const haystack = [
      name,
      full,
      first,
      last,
      u.email,
      u.username,
      u.role,
      u.title,
      u.department ?? u.department_name ?? u.dept,
      u.id, u.user_id
    ]
      .map(norm)
      .filter(Boolean)
      .join(" ");

    // query tokens: every token must appear
    const matchQ = tokens.length === 0 || tokens.every(t => haystack.includes(t));

    // department filter
    const rowDeptKey = norm(u.department ?? u.department_name ?? u.dept ?? "");
    const matchD = dept === "All" || rowDeptKey === deptKey;

    return matchQ && matchD;
  });
}, [data, q, dept]);


  // default column config (no filter UI)
  const defaultColumn = useMemo(
    () => ({
      Filter: () => null,
    }),
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,            // paginated rows
    setPageSize,
    state: { pageIndex, pageSize },
    gotoPage,
    pageOptions, 
    // canNextPage, canPreviousPage, nextPage, previousPage, pageOptions,
  } = useTable(
    {
      columns,
      data: filteredData,      // ✅ key fix: must be `data`, not `filteredData`
      defaultColumn,
      initialState: { pageIndex: 0, pageSize: 10 },
      autoResetPage: false,    // optional: keep page when filtering
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const pageCount = pageOptions.length;
  





  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(pageCount);

  React.useEffect(() => {
    setTotalPages(pageCount);
    setCurrentPage(pageIndex + 1);
  }, [pageCount, pageIndex]);












 return (
  <div className="incidents">
    <div className="ml-6 mr-6">
      {/* Card */}
      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-5">
        {/* Header */}
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Users Management</h2>
            <p className="text-sm text-gray-500">Manage user accounts and permissions</p>
          </div>
          <button
            onClick={() => openpopup?.(true)}
            className="inline-flex items-center gap-2 h-10 px-4 rounded-lg bg-[#0B0B0F] text-white hover:opacity-90 transition"
          >
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeWidth="2" d="M12 5v14M5 12h14" />
            </svg>
            <span className="text-sm font-medium">Add User</span>
          </button>
        </div>

        {/* Toolbar */}
        <div className="mt-4 grid grid-cols-1 md:grid-cols-[1fr_220px] gap-3">
          {/* Search */}
          <div className="relative">
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search by name or email..."
              className="w-full h-10 pl-9 pr-3 rounded-lg border border-gray-200 bg-gray-100/60 focus:bg-white focus:border-gray-300 focus:outline-none"
            />
            <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="7" strokeWidth="1.8" />
              <path d="M20 20l-3.5-3.5" strokeWidth="1.8" />
            </svg>
          </div>

          {/* Department filter */}
          <select
            value={dept}
            onChange={(e) => setDept(e.target.value)}
            className="h-10 rounded-lg border border-gray-200 bg-white px-3 text-sm text-gray-700 focus:outline-none"
          >
            {departmentOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt === "All" ? "All Departments" : opt}
              </option>
            ))}
          </select>
        </div>

        {/* Table */}
        <div className="mt-4 rounded-2xl border border-gray-200 overflow-hidden">
          <table {...getTableProps()} className="w-full text-sm text-gray-800">
            <thead className="bg-white">
              {headerGroups.map((hg) => (
                <tr {...hg.getHeaderGroupProps()} className="border-b border-gray-200">
                  {hg.headers.map((col) => {
                    const id = String(col.id || "").toLowerCase();
                    if (col.dontshow || id === "status") return null; // remove Status column
                    return (
                      <th
                        {...col.getHeaderProps(col.getSortByToggleProps())}
                        className="text-left font-medium text-gray-700"
                        style={{ padding: "12px 16px" }}
                      >
                        <div className="flex items-center gap-1.5">
                          {col.render("Header")}
                          <span className="sort-icon opacity-60">
                            {col.isSorted
                              ? (col.isSortedDesc ? <img src={SortDown} alt="▼" /> : <img src={SortUp} alt="▲" />)
                              : null}
                          </span>
                        </div>
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()} className="bg-white">
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className="hover:bg-gray-50 transition-colors border-t border-gray-100"
                  >
                    {row.cells.map((cell) => {
                      const id = String(cell.column.id || "").toLowerCase();
                      if (cell.column.dontshow || id === "status") return null;

                      // Actions cell
                      if (id === "actions") {
                        return (
                          <td {...cell.getCellProps()} style={{ padding: "12px 16px" }}>
                            <div className="flex items-center gap-3">
                              <button
                                onClick={(e) => { e.stopPropagation(); if (row.original?.onEdit) row.original.onEdit(); }}
                                className="p-1.5 rounded-md hover:bg-gray-100"
                                title="Edit"
                              >
                                <svg className="w-4.5 h-4.5 text-gray-700" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeWidth="1.7" d="M12 20h9" />
                                  <path strokeWidth="1.7" d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" />
                                </svg>
                              </button>
                              <button
                                onClick={(e) => { e.stopPropagation(); if (row.original?.onDelete) row.original.onDelete(); }}
                                className="p-1.5 rounded-md hover:bg-red-50"
                                title="Delete"
                              >
                                <svg className="w-4.5 h-4.5 text-red-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                  <path strokeWidth="1.7" d="M3 6h18" />
                                  <path strokeWidth="1.7" d="M8 6v14a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V6" />
                                  <path strokeWidth="1.7" d="M10 11v6M14 11v6" />
                                  <path strokeWidth="1.7" d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
                                </svg>
                              </button>
                            </div>
                          </td>
                        );
                      }

                      // Name column emphasis
                      if (id === "name") {
                        return (
                          <td {...cell.getCellProps()} style={{ padding: "12px 16px" }}>
                            <span className="text-gray-900 font-medium">{cell.render("Cell")}</span>
                          </td>
                        );
                      }

                      return (
                        <td
                          {...cell.getCellProps()}
                          className="cursor-pointer"
                          style={{ padding: "12px 16px" }}
                        >
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="text-sm text-gray-500 mt-3">
          Showing {page?.length ?? 0} of {filteredData.length} users
        </div>
      </div>
    </div>
  </div>
);




};

export default IncidentsTable;